module.exports = __webpack_public_path__ + "static/a9ff03669cbf70343dc2c98f42ba2feed57794b93eff37027869d87e1ed5d83b-d454168b14169e8f11af8ad59e7e8682.png";